import { Navigate, Outlet } from "react-router-dom";
import {
  deleteToken,
  getSessionData,
} from "../../../helpers/token/refreshToken";

//entras a register/login/reset/validation
export const ProtectedRoute = ({ children, redirectTo = "/" }) => {
  const data = getSessionData();

  if (data == null) {
    deleteToken("etknre");
    deleteToken("dttkn");
    return children ? children : <Outlet />;
  }

  return <Navigate to={redirectTo} />;
};

//entras a profile booking traveller
export const ProtectedEmployeeRoute = ({ children, redirectTo = "/" }) => {
  const data = getSessionData();

  if (data == null) {
    deleteToken("etknre");
    deleteToken("dttkn");
    return <Navigate to={redirectTo} />;
  }

  return children ? children : <Outlet />;
};
